<template>
  <div>
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>任务下载列表</h4>
        <span class="f-s-14 c-m-l-15">操作导出后产生的任务列表</span>
      </div>
      <div class="c-flex">
        <el-input
          placeholder="请输入关键词"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <!-- <el-button
          size="mini"
          class="filter-item"
          type="primary"
          icon="el-icon-download"
          @click="handleDownload()"
        >
          下载
        </el-button> -->
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table ref="table" height="calc(100% - 50px)" :data="fpi.data">
          <el-table-column prop="name" label="任务名称" min-width="120px"></el-table-column>
          <el-table-column prop="fileName" label="文件名称" min-width="120px"></el-table-column>
          <el-table-column prop="taskState" label="任务状态" min-width="120px">
            <template slot-scope="scope">
              <el-tag effect="plain" v-if="scope.row.taskState == '0'">
                {{ osg.codelabel('taskState', scope.row.taskState) }}
              </el-tag>
              <el-tag effect="dark" v-else-if="scope.row.taskState == '1'" type="success">
                {{ osg.codelabel('taskState', scope.row.taskState) }}
              </el-tag>
              <el-tag effect="dark" v-else-if="scope.row.taskState == '-2'" type="danger">
                {{ osg.codelabel('taskState', scope.row.taskState) }}
              </el-tag>
              <el-tag effect="dark" v-else-if="scope.row.taskState == '-1'" type="info">
                {{ osg.codelabel('taskState', scope.row.taskState) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="progress"
            label="任务进度（%）"
            min-width="120px"
          ></el-table-column>
          <el-table-column prop="createTime" label="创建时间" min-width="140px"></el-table-column>
          <el-table-column prop="createUserName" label="创建人" min-width="120px"></el-table-column>
          <el-table-column prop="faileReason" label="失败原因" min-width="120px"></el-table-column>
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope" v-if="scope.row.taskState == '1' && scope.row.fileid">
              <el-button
                size="mini"
                class="filter-item"
                type="text"
                icon="el-icon-download"
                @click="handleDownload(scope.row)"
              >
                下载
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'stask',
  data() {
    return {
      name: 'stask',
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: {},
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {
        codecfg_taskState: { codeId: 'taskState' }
      },
      state: '', //已归档 archived
      refresh: true, //表格刷新
      user: {}
    };
  },
  beforeCreate() {
    window.$this = this;
  },
  async mounted() {
    this.doInit();
    this.osg.getFields('stask', () => {
      this.osg.getFpi();
      this.getData();
    });
  },
  methods: {
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = { exts: {} };
      if (this.$refs.formData) this.$refs.formData.resetFields();
      this.$util.renderExtField(this.extFields, this.formData);
      this.state = this.osg.param('state');
      //根据浏览器缓存获取当前选择的账号，如果没有则调接口查询
      if (JSON.parse(sessionStorage.getItem('loginAccount'))) {
        this.user = JSON.parse(sessionStorage.getItem('loginAccount'));
      }
    },
    getData() {
      var params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'in:state|integer#and': this.state == 'archived' ? -1 : 1,
        'regex:name|string#or': this.searchValue,
        userId: this.user._id,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      //添加过滤器参数
      $that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('basic/stask/query.do', params, res => {
        this.refresh = false;
        this.fpi = res;
        this.refresh = true;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    //下载
    handleDownload(row) {
      // var elemIF = document.createElement('iframe');
      // elemIF.style.display = 'none';
      // document.body.appendChild(elemIF);
      window.open(row.fileid);
    },
    doEdit(row) {
      var row = this.$util.deepCopy(row);
      this.$util.renderExtField(this.extFields, row);
      this.formData = row;
      this.osg.getSubdistricts(this.formData.area, result => {
        this.options.subdistricts = result;
        this.$forceUpdate();
      });
      this.openDetail = true;
    },
    doSave() {
      if (this.osg.validate()) {
        this.osg.ajax('basic/stask/upsert.do', this.formData, () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    doEnable(id) {
      this.osg.ajax('basic/stask/enable/' + id + '.do', null, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax('basic/stask/disable/' + id + '.do', null, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    }
  },
  watch: {
    // $route() {
    //   window.$this = this;
    //   this.doInit();
    //   this.osg.getFpi();
    //   this.getData();
    // }
  }
};
</script>
